import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/logofiltro+bertot.svg'
import _imports_1 from '../../assets/fdo_header.jpg'
import _imports_2 from '../../assets/castellano.jpg'
import _imports_3 from '../../assets/ingles.jpg'
import _imports_4 from '../../assets/portugues.jpg'


const _hoisted_1 = { class: "backgroundNav" }
const _hoisted_2 = { class: "languages-l" }

import MobileMenu from './MobileMenu.vue';

import { useI18n } from 'vue-i18n';

// Usar la instancia de i18n

export default /*@__PURE__*/_defineComponent({
  __name: 'Nav-bar',
  setup(__props) {


const { locale } = useI18n();

// Función para cambiar el idioma
const changeLocale = (lang: string) => {
  locale.value = lang;  // Cambiar el idioma de la aplicación
  localStorage.setItem('locale', lang); // Guardar el idioma seleccionado en localStorage
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("img", {
      class: "image-logo",
      src: _imports_0,
      alt: ""
    }, null, -1)),
    _cache[4] || (_cache[4] = _createElementVNode("img", {
      class: "large-header",
      src: _imports_1,
      alt: ""
    }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: "languages",
        src: _imports_2,
        alt: "Español",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (changeLocale('es')))
      }),
      _createElementVNode("img", {
        class: "languages",
        src: _imports_3,
        alt: "English",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (changeLocale('en')))
      }),
      _createElementVNode("img", {
        class: "languages",
        src: _imports_4,
        alt: "Português",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (changeLocale('pt')))
      })
    ]),
    _createVNode(MobileMenu)
  ]))
}
}

})